import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import testimonials from '../../data/testimonials'
import linkedinIcon from '../../assets/testimonials/linkedin-icon.svg'

const Capacity = () => {
  return (
    <section id='testimonials'>
      <div className="container brd-white top-none bottom-none p-5">
        <h2 className="title-intro c-white">Testimonials</h2>
        <div className="s-50"></div>
        
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
          }}
          pagination={{ 
            clickable: true,
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          loop={true}
          style={{ paddingBottom: '60px' }}
        >
          {testimonials.map((testimonial) => (
            <SwiperSlide key={testimonial.id} style={{ height: 'auto' }}>
              <div className="brd-white p-5" style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '20px' }}>
                    <img 
                      src={testimonial.photo} 
                      alt={testimonial.name} 
                      style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', marginRight: '15px', flexShrink: 0 }}
                    />
                    <div>
                      <p className="c-white" style={{ margin: 0, fontWeight: 'bold' }}>
                        {testimonial.name} <img src={testimonial.flag} alt="flag" width="24" height="16" style={{ marginLeft: '5px' }} />
                      </p>
                      <p className="c-white" style={{ margin: '5px 0', fontSize: '14px' }}>{testimonial.position}</p>
                      <div style={{ marginTop: '10px' }}>
                        {[...Array(5)].map((_, i) => (
                          <span key={i} style={{ color: '#FFD700', fontSize: '18px', marginLeft: 6 }}>★</span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="c-white" style={{ marginBottom: '20px' }}>"{testimonial.text}"</p>
                </div>
                <div>
                  <a href={testimonial.linkedin} target="_blank" rel="nofollow noopener noreferrer">
                    <img src={linkedinIcon} alt="LinkedIn" width="40" height="40" />
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="s-50"></div>
      </div>
    </section>
  )
}

export {Capacity}
